import { checkIfiOS } from '../components/expand/expandUtils/expandUtils';

import {
  ON_CLICK_MEDIA,
  SET_EXPAND_STATE,
  SET_COMMENTS,
  ADD_COMMENTS,
  SET_COMMENTS_PAGING,
  COMMENTS_LOADING,
  EXPAND_ON_ADD_MEDIAS,
  EXPAND_IS_LOADING_MORE_MEDIAS,
  SET_MEDIA_LINKS,
  SET_MEDIA_LINKS_LOADING,
  UPDATE_STORY_PROGRESS,
  SET_POSTS,
  SET_STORIES,
  SET_BASE_URL,
  IS_FIRST_LOAD,
  ALL_COMMENTS_LOADED,
  SET_CURRENT_VIDEO_REF,
  SET_CURRENT_VIDEO_ALBUM_REF,
  SET_CURRENT_MUTE,
  SET_CURRENT_PLAY,
  SET_VIDEO_FULLSCREEN,
} from '../constants';

export const initState = {
  currentMedia: {},
  currentIndex: null,
  medias: [],
  pagination: {},
  user: {},
  comments: {},
  commentsPagination: {},
  loadingComments: {},
  isLodingMedias: false,
  mediaLinks: {},
  loadingMediaLinks: {},
  posts: [],
  stories: [],
  liveSiteBaseUrl: '',
  expandLoaded: false,
  allCommentsLoaded: true,
  allMediaLinksLoaded: true,
  currentVideoRef: '',
  currentMute: !checkIfiOS() ? true : false,
  currentPlay: !checkIfiOS() ? true : false,
  iOSMobile: checkIfiOS(),
  isVideoFullscreen: false,
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case IS_FIRST_LOAD:
      return {
        ...state,
        expandLoaded: action.payload,
      };
    case ON_CLICK_MEDIA:
      return {
        ...state,
        currentMedia: action.payload.media,
        currentIndex: action.payload.index,
      };
    case SET_EXPAND_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_COMMENTS:
      return {
        ...state,
        comments: {
          ...state.comments,
          ...action.payload,
        },
      };
    case ADD_COMMENTS:
      const { mediaId, addedComments } = action.payload;
      return {
        ...state,
        comments: {
          ...state.comments,
          [mediaId]: [...state.comments[mediaId], ...addedComments],
        },
      };
    case SET_COMMENTS_PAGING:
      return {
        ...state,
        commentsPagination: {
          ...state.commentsPagination,
          ...action.payload,
        },
      };
    case COMMENTS_LOADING:
      return {
        ...state,
        loadingComments: {
          ...state.loadingComments,
          ...action.payload.commentsLoadingObj,
        },
      };
    case ALL_COMMENTS_LOADED:
      return {
        ...state,
        allCommentsLoaded: action.payload,
      };
    case EXPAND_IS_LOADING_MORE_MEDIAS:
      return {
        ...state,
        isLodingMedias: action.payload,
      };
    case EXPAND_ON_ADD_MEDIAS:
      return {
        ...state,
        medias: state.medias.concat(action.payload.medias),
        pagination: action.payload.pagination,
        isLodingMedias: false,
      };
    case SET_MEDIA_LINKS:
      return {
        ...state,
        mediaLinks: {
          ...state.mediaLinks,
          ...action.payload,
        },
      };
    case SET_MEDIA_LINKS_LOADING:
      return {
        ...state,
        // loadingMediaLinks: {
        //   ...state.loadingMediaLinks,
        //   ...action.payload,
        // },
        allMediaLinksLoaded: action.payload,
      };
    case UPDATE_STORY_PROGRESS:
      let currentMedia;
      const mediasToSet = state.medias.map((media, index) => {
        if (index === action.storyIndex) {
          currentMedia = { ...media, progress: action.progress };
          return currentMedia;
        }
        return media;
      });
      return {
        ...state,
        medias: mediasToSet,
        currentMedia,
      };
    case SET_POSTS:
      return {
        ...state,
        medias: [...state.posts],
        currentIndex: 0,
        currentMedia: state.posts[0],
      };
    case SET_STORIES:
      return {
        ...state,
        medias: [...state.stories],
        currentIndex: 0,
        currentMedia: state.stories[0],
      };
    case SET_BASE_URL:
      return {
        ...state,
        liveSiteBaseUrl: action.payload,
      };
    case SET_CURRENT_VIDEO_REF:
      return {
        ...state,
        currentVideoRef: action.payload,
      };
    case SET_CURRENT_VIDEO_ALBUM_REF:
      return {
        ...state,
        currentVideoRef: { ...state.currentVideoRef, ...action.payload },
      };
    case SET_CURRENT_MUTE:
      return {
        ...state,
        currentMute: action.payload,
      };
    case SET_CURRENT_PLAY:
      return {
        ...state,
        currentPlay: action.payload,
      };
    case SET_VIDEO_FULLSCREEN:
      return {
        ...state,
        isVideoFullscreen: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
